import React from 'react'
import { Link } from 'react-router-dom'
import qs from 'qs'


// utils
import changeInputHandler from 'app/views/utils/changeInputHandler'
import { resetPassword } from 'app/views/utils/auth'
import validate from './validation'

const propTypes = {}
const defaultProps = {}

class ResetPassword extends React.Component {
  constructor(props) {
    super(props)

    this.handleInputChange = changeInputHandler.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)

    this.state = {
      fields: {},
      errors: {},
      error: '',
    }
  }

  async handleSubmit() {
    this.setState({ error: '' })
    const {
      location: {
        search,
      },
    } = this.props
    const { fields } = this.state
    const errors = validate(fields)

    if (Object.keys(errors).length) {
      return this.setState({
        errors,
      })
    }

    const queryString = search.substr(1)
    const queryParams = qs.parse(queryString)
    const { username } = queryParams

    if (!username) {
      this.setState({ error: 'Username parameter is required' })
      return false
    }
    const payload = {
      verificationCode: fields.verificationCode,
      password: fields.password,
      username: decodeURIComponent(username),
    }

    await resetPassword(payload)
      .then(() => {
        this.props.history.push('/login')
      })
      .catch((err) => {
        console.error(err)
        this.setState({
          error: err.message,
        })
      })
  }

  render() {
    const {
      errors,
      error,
    } = this.state

    return (

      <div data-test-id="reset-password-component" className="uk-background-muted" style={{ minHeight: 'calc(100vh - 10px)' }}>
        <div className="uk-container" style={{ maxWidth: 550 }}>
          <div className="uk-section uk-margin-large-bottom">
            <div className="uk-text-center">
              <Link className="uk-navbar-item uk-logo uk-navbar-toggle" to="/">
                <img src="/static/images/logo.png" style={{ maxWidth: 129 }} alt="Logo" />
              </Link>
              <h3>Set New Password</h3>
            </div>
            <div className="uk-card uk-card-default uk-card-body uk-padding-large uk-margin-top" style={{ paddingBottom: 30 }}>
              <form>
                <div className="uk-margin">
                  <input
                    name="verificationCode"
                    type="text"
                    placeholder="Verification Code"
                    className="uk-input"
                    onChange={this.handleInputChange}
                  />
                </div>
                <span className="uk-text-danger">{errors.verificationCode}</span>
                <div className="uk-margin">
                  <input
                    name="password"
                    type="password"
                    placeholder="New Password"
                    className="uk-input"
                    onChange={this.handleInputChange}
                  />
                </div>
                <span className="uk-text-danger">{errors.password}</span>
                <div className="uk-margin">
                  <input
                    name="confirmPassword"
                    type="password"
                    placeholder="Confirm Password"
                    className="uk-input"
                    onChange={this.handleInputChange}
                  />
                </div>
                <span className="uk-text-danger">{errors.confirmPassword}</span>
              </form>
              <span className="uk-text-danger">{error}</span>
              <div className="uk-margin">
                <button
                  type="submit"
                  className="uk-button uk-button-primary tm-button-primary"
                  onClick={this.handleSubmit}
                  style={{ width: '100%' }}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ResetPassword.propTypes = propTypes
ResetPassword.defaultProps = defaultProps

export default ResetPassword
